export const _faNumToEnNum = (value: any) => {
    let str = value.replace(',', '');
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    for (let i = 0; i < 10; i++) {
        str = str.replaceAll(persianDigits[i], i);
    }
    return str;
}